import React from 'react'
import { Text, TabGroup, Heading } from 'base-ui'
import { PageWrapper } from './PageWrapper'
import Highlighter from './Highlight'
import { TabGroup as TabGroupExample } from '../examples/TabGroup'

export const TabPanelOneExampleComponent = () => {
  return <div>Tab Panel One Component</div>
}
export const TabPanelTwoExampleComponent = () => {
  return <div>Tab Panel Two Component</div>
}

const TabGroupComponent = () => {
  return (
    <PageWrapper title="TabGroup">
      <Text size="md">
        Use to navigate between groups of content that are related and at the same level of hierarchy.
      </Text>
      <div>
      <TabGroup
          selectColorText={'text-black-400'}
          selectedColorBackground={'bg-black'}
          selectedColorBorder={'border-black'}
          tabConfiguration={[{name: 'Tab One'}, {name: 'Tab Two'}]}
          pannelConfiguration={[
            {
            name: 'Tab Panel One',
            component: TabPanelOneExampleComponent
          },
          {
            name: 'Tab Panel Two',
            component: TabPanelTwoExampleComponent
          }
          ]}
        />
        <TabGroup
          tabNumber={1}
          showTabNumberIcon={true}
          selectColorText={'text-black-400'}
          selectedColorBackground={'bg-black'}
          selectedColorBorder={'border-black'}
          tabConfiguration={[{name: 'Tab One'}, {name: 'Tab Two'}]}
          pannelConfiguration={[
            {
            name: 'Tab Panel One',
            component: TabPanelOneExampleComponent
          },
          {
            name: 'Tab Panel Two',
            component: TabPanelTwoExampleComponent
          }
          ]}
        />
        </div>
      <Heading size="h3">Usage</Heading>
      <Highlighter code={TabGroupExample} language='jsx' />
    </PageWrapper>
  )
}

export default TabGroupComponent
